/****************ELEMENTS*****************/
//this obj define, the actions realeted to each 
//th>table header and td
export const tableDetail = {
    entity: 'providerProfit',//name table on the db
    dest: 'providerProfit',//name of the entity on the system

    //action for body 
    //left click, directly to the fullcont 
    tdDataDetail: `data-detail='{ "click": [ {"dest":"ripple" },
                                            {"dest":"providerProfit", "elem":"fullcont", "id":"providerProfit-fullcont", "act":"callData", "dbid": "#dbid"},
                                            {"dest":"providerProfit", "elem":"fullcont", "id":"providerProfit-fullcont", "act":"callUnpaidInvoices", "dbid": "#dbid"}  ],
                                
                                 "clickRight": [{"dest":"providerProfit", "elem":"dt", "act":"trMenu", "id":"trMenu",  "entity":"report", "dbid": "#dbid" } ]  }'`,

    filter: {
        mainFilterFields: [""],
        mainFilterValues: ["", ""],
        andFilterFields: [""],
        andFilterValues: [""],
    }

}

/****************ELEMENTS*****************/

//each element could organize their data diferent
export function organizeRow(data) { //console.log('organizeRow>')

    var newData = []

    if (data.length === 0) {
        newData.push({
            id: 'nothing', colum: [{ label: 'No Results', span: '' },
            { label: '', span: '' },
            { label: '', span: '' },]
        })
        return newData
    }

    data.forEach((elem) => {
        newData.push(
            {
                id: elem.provider_id, colum: [{
                    label: elem.provider_name,
                    span: elem.total_earnings,
                    style: {
                        tdClass: "tdWithAvatar",
                        avatar: elem.avatar,
                        avatarColor: elem.avatarColor,
                        avatarColorLetter: elem.avatarColorLetter,
                        avatarLetter: elem.avatarLetter,
                    }
                },
                { label: elem.last_24_hours, span:elem.last_24_hours_income },
                { label: elem.last_7_days, span:elem.last_7_days_income },
                { label: elem.last_15_days, span:elem.last_15_days_income },
                { label: elem.last_30_days, span:elem.last_30_days_income },
                { label: elem.last_90_days, span:elem.last_90_days_income },
                { label: elem.over_90_days, span:elem.over_90_days_income },
                ]
            }
        )/*push*/
    })/*forEach*/

    return newData
}/*organizeRow*/